import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Spinner } from '@/components/spinner';
import { useAppContext } from '@/context/app';
import { CreateUserWizardStep1, SimpleUserGroup } from './Step1';
// import { useWizard, WizardData, WizardProvider } from './context';
import { CreateUserWizardStep2 } from './Step2';
import { UseFormReturn } from 'react-hook-form';
import { addServerErrors } from '@/components/forms/common/FormBase';
import { FormData, User, QuickCreateUserForm } from './types'
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { cleanData, WizardData } from './data';

const maxStep = 2

export const CreateUserWizardBody = ({ onDone }: {
  onDone: () => void
}) => {
  const {services, session, translates} = useAppContext()
  const { wizardData, updateWizardData, step, setStep } = useWizard()

  const handle = (data: WizardData, form: UseFormReturn<FormData, any, undefined>): Promise<void> => {
    // delete data.id
    return services.session.fetchWithToken(`/api/manager/users/wizard/create`, {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        translates && addServerErrors(form, translates, erros)
        return
      }
      // const respData = await r.json()
      onDone()
    })
  }

  if (step === 0) {
    return <CreateUserWizardStep1  />
  } else if (step === 1) {
    return <CreateUserWizardStep2 onDone={handle} />
  } else return <Spinner />
}

export const UserCreateWizard = ({ user, onDone }: {
  user?: User | undefined
  onDone: () => void
}) => {
  return <div className='user-create-wizard'>
    <WizardProvider initialData={user ? {
      ...cleanData(),
      user
    } : cleanData()} maxStep={maxStep}>
      <CreateUserWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const CreateUserWizardPopup = ({ user, onClose }: {
  user?: User | undefined
  onClose: () => void
}) => {
  return <UserCreateWizard user={user} onDone={onClose} />
}
